module.exports = __webpack_public_path__ + "img/logo_client.6ec4b5bc.png";